import React, { PropTypes } from 'react'
import CSSModules from 'react-css-modules'
import classNames from 'classnames'

import styles from './grid-form-label.css'

const GridFormLabel = ({ name, field, optional }) => (
  <label styleName="label">
    <span
      styleName={
        classNames({
          'name-active': field.active || field.value,
          'name-inactive': !field.active && !field.value,
        })
      }
    >
      {name}
    </span>
    {optional &&
      <span
        styleName={
          classNames({
            'optional-active': field.active || field.value,
            'optional-inactive': !field.active && !field.value,
          })
        }
      >
        {optional}
      </span>
    }
  </label>
)

GridFormLabel.propTypes = {
  field: PropTypes.object.isRequired,
  name: PropTypes.string.isRequired,
  optional: PropTypes.string,
}

export default CSSModules(GridFormLabel, styles)



/** WEBPACK FOOTER **
 ** ./src/components/grid-form-label/grid-form-label.js
 **/